import {
    TAB_ACTIVATION,
    TAB_ALTERNATIVE_ACTIVATION,
    TAB_AVAILABLE_INDEXES_SET,
    TAB_NUMEROTED_SET
} from 'store/mutation-types'

export default (tabsArray) => ({
    namespaced: true,

    state: {
        tabsArray,
        activeTab: 0,
        isAlternated: false,
        available_tabs_indexes: null, // null means all tabs are available if it is an array then display only the tabs having theirs indexes inside this array
        numeroted_tab_header: false // when true add the current tab index (+ 1) before the tab heading
    },

    mutations: {
        [TAB_ACTIVATION](state, value) {
            state.activeTab = value
        },

        [TAB_ALTERNATIVE_ACTIVATION](state, value) {
            // state.activeTab = value
            state.isAlternated = value
        },

        [TAB_AVAILABLE_INDEXES_SET](state, value) {
            state.available_tabs_indexes = value
        },

        [TAB_NUMEROTED_SET](state, value) {
            state.numeroted_tab_header = value
        },
    },

    getters: {
        tabHeadings(state, getters, rootState, rootGetters) {
            if (state.available_tabs_indexes == null)
                return state.tabsArray.map((tab, idx) => {

                    if (_.has(tab, 'display_condition') && !tab.display_condition(rootState, rootGetters))
                        return null

                    if (idx === state.activeTab)
                        if (state.isAlternated && _.has(tab, 'alternative_name'))
                            if (state.numeroted_tab_header)
                                return String(idx + 1) + ' - ' + tab.alternative_name
                    else {
                        return tab.alternative_name
                    }

                    if (state.numeroted_tab_header)
                        return String(idx + 1) + ' - ' + tab.display_name
                    return tab.display_name
                })
            else {
                var arr = _.filter(state.tabsArray, (tab) => {
                    return _.find(state.available_tabs_indexes, (avail_tab_idx) => {
                        return _.indexOf(state.tabsArray, tab) === avail_tab_idx
                    }) != undefined
                })

                return arr.map((tab, idx) => {
                    if (_.has(tab, 'display_condition') && !tab.display_condition(rootState, rootGetters))
                        return null

                    if (idx === state.activeTab)
                        if (state.isAlternated && _.has(tab, 'alternative_name'))
                            if (state.numeroted_tab_header)
                                return String(idx + 1) + ' - ' + tab.alternative_name
                    else {
                        return tab.alternative_name
                    }

                    if (state.numeroted_tab_header)
                        return String(idx + 1) + ' - ' + tab.display_name
                    return tab.display_name
                })
            }
        }
    },

})

export const resolveMutation = (moduleName, alternative = false) => alternative ?
    `tabs/${moduleName}/${TAB_ALTERNATIVE_ACTIVATION}` : `tabs/${moduleName}/${TAB_ACTIVATION}`
export const resolveGetter = (moduleName, name) => `tabs/${moduleName}/${name}`
export const resolveState = (moduleName, state) => state.tabs[moduleName]



// WEBPACK FOOTER //
// ./client/store/modules/tabs/tabManagerFactory.js